module.exports = [
  "aenp",
  "ab",
  "ac",
  "ace",
  "ad",
  "ae",
  "ag",
  "al",
  "amba",
  "ans",
  "apb",
  "aps",
  "aps&coks",
  "as",
  "asa",
  "avv",
  "bpk",
  "bt",
  "bv",
  "bvba",
  "ca",
  "cie",
  "cies",
  "co",
  "corp",
  "cv",
  "cva",
  "cvoa",
  "da",
  "dba",
  "dd",
  "dno",
  "doo",
  "ee",
  "eeg",
  "eirl",
  "elp",
  "enr",
  "enrg",
  "eood",
  "epe",
  "eurl",
  "ev",
  "gbr",
  "gcv",
  "gesmbh",
  "gie",
  "gmbh&cokg",
  "gmbh",
  "hb",
  "hf",
  "ibc",
  "inc",
  "incorporée",
  "incorporated",
  "is",
  "jtd",
  "jsc",
  "kas",
  "kb",
  "kd",
  "kda",
  "kdd",
  "kft",
  "kg",
  "kgaa",
  "kk",
  "kkt",
  "kolsrk",
  "komsrk",
  "ks",
  "kv",
  "ky",
  "lda",
  "ldc",
  "limited",
  "limitée",
  "llc",
  "llp",
  "lp",
  "ltd",
  "ltda",
  "ltée",
  "na",
  "nt",
  "nv",
  "oao",
  "oe",
  "ohg",
  "ood",
  "ooo",
  "oü",
  "oy",
  "oyj",
  "partnership",
  "pl",
  "pcltd",
  "plc",
  "pma",
  "pmdn",
  "prc",
  "prpltd",
  "pt",
  "pty",
  "ras",
  "rt",
  "sderl",
  "senc",
  "sennc",
  "sencrl",
  "sa",
  "sadecv",
  "safi",
  "saica",
  "sapa",
  "sarl",
  "sas",
  "sc",
  "sca",
  "scp",
  "scs",
  "sdnbhd",
  "sgps",
  "sk",
  "snc",
  "société",
  "soparfi",
  "sp",
  "spa",
  "spolsro",
  "sprl",
  "spzoo",
  "srl",
  "td",
  "tls",
  "veb",
  "vof",
  "vos",
  "zao"
]
